import { IconButton, makeStyles } from '@material-ui/core';
import { useContext, useEffect, useMemo, useState } from 'react';
import { SideBar } from './components/SideBar';
import { Switch, Route, useHistory, RouteComponentProps, useLocation } from "react-router-dom";
import adminRoutes from '../../config/adminRoutes';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { AdminDateContext, OfficeContext, PlanEatUserContext } from '../../config/Context';
import { IOfficeContent, IVersionedObject } from '../../planEatApi/PlanEatFacade';
import { MdLogout, MdPerson, MdSettings } from 'react-icons/md';
import { useQuery } from '../../hooks/useQuery';

const useStyles = makeStyles((theme: any) => ({
    topbarContainer: {
        position: 'absolute',
        width: 'calc(100% - 210px);',
        height: 50,
        top: 0,
        right: 0,
        background: '#FFFFFF',
        boxShadow: '0px 4px 7px rgba(11, 37, 89, 0.08)'
    },
    topbarTitle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 30,
        top: 0,
        bottom: 0,
        position: 'absolute',
        height: '100%',
        fontSize: 24,
        fontWeight: 700,
    },
    topbarButtonsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    adminContentContainer: {
        background: '#F3F3F9',
        marginTop: 50,
        position: 'absolute',
        minHeight: '100%',
        width: 'calc(100% - 210px);',
        right: 0,
        padding: 30
    },
    dropDownButton: {
        background: 'none',
        backgroundColor: 'none',
        fontSize: 14,
        fontWeight: 700,
        color: 'black !important',
        border: 'none',
        outline: 0,
        width: 'fit-content',
    },
}));


interface Props {

}



export const Admin: React.FC<Props> = ({ }) => {
    const classes = useStyles();

    // Routing
    let history = useHistory();
    const location = useLocation();
    let queryParams = useQuery()

    // State
    const [sideBarItemSelected, setSideBarItemSelected] = useState<string>('');
    const [pageTilte, setPageTitle] = useState<string>('Dashboard');
    const [date, setDate] = useState<Date>(new Date());

    // Entities
    const [offices, setOffices] = useState<IVersionedObject<IOfficeContent>[]>([]);
    const planEatUserContext = useContext(PlanEatUserContext);
    const officeContext = useContext(OfficeContext);

    // Context provider value
    const adminDateProviderValue = useMemo(() => ({date, setDate}),[date, setDate])

    useEffect(() => {
        if (sideBarItemSelected !== '/admin/dashboard') {
            setSideBarItemSelected('/admin/dashboard')
        }
    }, []);

    useEffect(() => {
        if (sideBarItemSelected === '') {
            setSideBarItemSelected('/admin/dashboard')
        } else {
            let curQueryParams = location.search
            if(curQueryParams.length > 0){
                history.push({
                    pathname: sideBarItemSelected,
                    search: curQueryParams.toString()
                })
            } else {
                history.push(sideBarItemSelected)
            }
        }
    }, [sideBarItemSelected]);

    useEffect(() => {
        adminRoutes.forEach((adminRoute) => {
            if (location.pathname === adminRoute.path) {
                setPageTitle(adminRoute.name)
                setSideBarItemSelected(adminRoute.path)
            }
        })
    }, [location.pathname])

    useEffect(() => {
        let token = localStorage.getItem("token")
        if(token){
            getOffices()
        }
    },[officeContext])

    const getOffices = async () => {
        await planEatApi.getOffices().then((response) => {
            setOffices(response.data)
        })
    }

    const postLogout = async () => {
        var token = localStorage.getItem('token');

        if(token){ 
            if(planEatUserContext?.planEatServiceUser){
                await planEatApi.postLogout(planEatUserContext?.planEatServiceUser.content.id)
                .then((response) =>{
                    localStorage.clear();
                })
                .catch((e) => {
                    localStorage.clear();
                })
            }
        } 
        officeContext?.setOffice(undefined)
        history.push("/")
    }

    const handleOfficeChange = (event: any) => {
        offices.map((office) => {
            if(office.content.id=== event.target.value){
                officeContext?.setOffice(office)
                localStorage.setItem("officeId",office.content.id)
            }
        })
    }

    return (
        <div style={{ 'background': '#F3F3F9 !important' }}>
            <div>
                <SideBar sideBarItemSelected={sideBarItemSelected} setSideBarItemSelected={setSideBarItemSelected} />
            </div>
            <div className={classes.topbarContainer}>
                <div className={classes.topbarTitle}>
                    {pageTilte}
                </div>
                <div className={classes.topbarButtonsContainer}>
                    {
                        officeContext?.office &&
                        <select
                        id="demo-customized-button"
                        aria-controls="demo-customized-menu"
                        aria-haspopup="true"
                        className={classes.dropDownButton}
                        onChange={handleOfficeChange}
                        value={officeContext?.office.content.id}>
                        {offices.map((office) => <option value={office.content.id} key={office.content.id}>{office.content.officeName}</option>)}
                    </select>
                    }

                    <IconButton  aria-label="profile" onClick={() => {setSideBarItemSelected('/admin/account')}}>
                        <MdSettings />
                    </IconButton>
                    <IconButton  aria-label="account" onClick={() => {setSideBarItemSelected('/admin/profile')}}>
                        <MdPerson />
                    </IconButton>
                    <IconButton  aria-label="logout" onClick={postLogout} >
                        <MdLogout style={{ color: 'red' }} />
                    </IconButton>
                </div>
            </div>
            <div className={classes.adminContentContainer}>
                <AdminDateContext.Provider value={adminDateProviderValue}>
                    <Switch>
                        {adminRoutes.map((route, index) => {
                            return (
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    exact={route.exact}
                                    render={(props: RouteComponentProps<any>) => (
                                        <route.component
                                            name={route.name}
                                            {...props}
                                            {...route.props}
                                        />
                                    )}
                                />
                            );
                        })}
                    </Switch>
                </AdminDateContext.Provider>
            </div>
        </div>
    );
}